/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { injectable } from 'inversify';
import { MasterAdminInvitePageAgent, getAgent } from './agent';
import { InviteUserProps } from './plugins';
import { logger as log } from '../../../common/logger';
const is = require('is_js');

const SERVICE_NAME = 'MasterAdminInvitePageService';

@injectable()
export class MasterAdminInvitePageService {
  private static instance: MasterAdminInvitePageService;
  public agent: MasterAdminInvitePageAgent;
  static displayName = 'MasterAdminInvitePageService';
  constructor(props: any = {}) {
    this.agent = getAgent();
  }
}
